import React, { useState } from "react";
import { Modal, Stack, CircularProgress, Box } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { postAPICall, putAPICall } from "lib/callApi";
import { useMaterialUIController } from "context";
import { ADD_KPI, UPDATE_KPI } from "lib/constants";
import { Formik, Form } from "formik";
import MDInput from "components/MDInput";
import { enqueueSnackbar } from "notistack";

function EditKpiModal({ open, handleClose, editModalData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [isRequestApiLoading, setIsRequestApiLoading] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: window.innerWidth < 600 ? "90%" : 550,
    bgcolor: darkMode ? "#1F283E" : "background.paper",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
    borderRadius: "0.5rem",
  };

  const editKpi = async (body) => {
    setIsRequestApiLoading(true);
    try {
      if (editModalData.kpiId) {
        const response = await putAPICall(`${UPDATE_KPI}/${editModalData.kpiId}`, true, body);
        if (!response?.data?.success) {
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "error",
              text: response?.data?.message || "Could not update Kpi. Please try again!",
            }),
            {
              variant: "custom",
            }
          );
          return;
        }
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Success",
            text: "Kpi updated succesfully!",
          }),
          {
            variant: "custom",
          }
        );
      } else {
        const response = await postAPICall(ADD_KPI, true, body);
        if (!response?.data?.success) {
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "error",
              text: response?.data?.message || "Could not add Kpi. Please try again!",
            }),
            {
              variant: "custom",
            }
          );
          return;
        }
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Success",
            text: "Kpi added succesfully!",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "error",
          text: `Could not ${editModalData.kpiId ? "update" : "add"} kpi, please try again!`,
        }),
        {
          variant: "custom",
        }
      );
    } finally {
      handleClose();
      setIsRequestApiLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {isRequestApiLoading ? (
          <Stack alignItems="center">
            <CircularProgress
              sx={{
                position: "fixed",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
              color="info"
              size="10vh"
            />
          </Stack>
        ) : (
          ""
        )}

        <Formik
          style={{ marginTop: "2rem" }}
          initialValues={{ name: editModalData.name }}
          enableReinitialize
          onSubmit={editKpi}
        >
          {({ errors, values, touched, setValues }) => (
            <Form>
              <MDInput
                name="name"
                error={!!touched.name && errors.name}
                helperText={touched.name && errors.name}
                sx={{ marginTop: "1.4rem" }}
                value={values.name || ""}
                label="Name"
                fullWidth
                onChange={(e) => setValues(() => ({ name: e.target.value }))}
              />
              <MDBox mt={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton onClick={handleClose} color="gray80" style={{ marginRight: "10px" }}>
                  Cancel
                </MDButton>
                <MDButton type="submit" color="primaryRed" disabled={isRequestApiLoading}>
                  {isRequestApiLoading ? "Loading..." : `${editModalData.kpiId ? "Save" : "Add"}`}
                </MDButton>
              </MDBox>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default EditKpiModal;
